import { jsx as t } from "react/jsx-runtime";
import { isValidElement as p, cloneElement as c } from "react";
import { cn as u } from "./designsystem-ui-react47.js";
import { Tag as l } from "./designsystem-ui-react40.js";
function d({
  tags: e,
  defaultVariant: o = "base",
  defaultProps: i,
  className: m
}) {
  return !e || e.length === 0 ? null : /* @__PURE__ */ t("div", { className: u("tw-flex tw-gap-x-2 tw-flex-wrap", m), children: e.map((r, n) => {
    if (!r)
      return null;
    if (p(r))
      return c(r, { key: `tag-${n}` });
    if (typeof r == "string")
      return /* @__PURE__ */ t(l, { variant: o, ...i || {}, children: r }, `tag-${n}`);
    const { text: f, ...a } = r;
    return /* @__PURE__ */ t(l, { ...i || {}, ...a, children: f }, `tag-${n}`);
  }) });
}
export {
  d as CardTags
};
